/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouterStatusDto } from '../../models/router-status-dto';

export interface RouterStatus$Params {

/**
 * The serial number of the router
 */
  sn: string;
}

export function routerStatus(http: HttpClient, rootUrl: string, params: RouterStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<RouterStatusDto>> {
  const rb = new RequestBuilder(rootUrl, routerStatus.PATH, 'get');
  if (params) {
    rb.query('sn', params.sn, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RouterStatusDto>;
    })
  );
}

routerStatus.PATH = '/api/srsc/routerStatus';
